import React from "react";

import * as component from "../../../../components/util/component";
import { PopupPanel } from "../../../styles/Common/panel";
import {
  List,
  ListItem,
  ListItemTitle,
  ListItemTitleMain,
  ListItemTitleIcon,
  ListItemTitleAside,
} from "../../../styles/Common/list";
import { AssignmentsContent } from "../../../styles/popupStyles";
import ContentLargeIcon from "calcite-ui-icons-react/ContentLargeIcon";
import CreditsIcon from "calcite-ui-icons-react/CreditsIcon";
import CubeIcon from "calcite-ui-icons-react/CubeIcon";
import DeskIcon from "calcite-ui-icons-react/DeskIcon";
import ServicesIcon from "calcite-ui-icons-react/ServicesIcon";
import WidgetsSourceIcon from "calcite-ui-icons-react/WidgetsSourceIcon";
import ClockIcon from "calcite-ui-icons-react/ClockIcon";
import MeasureAreaIcon from "calcite-ui-icons-react/MeasureAreaIcon";
import Topic from "../../../../context/Topic";
import * as aiimUtil from "../../../../aiim/util/aiimUtil";
import * as officePlanUtil from "../../../base/officePlanUtil";
import * as queryUtil from "../../../base/queryUtil";
import * as transactions from "../../../base/transaction/transactions";
import * as selectionUtil from "../../../../aiim/util/selectionUtil";
import * as sourceUtil from "../../../base/sourceUtil";
import FieldNames from "../../../../aiim/datasets/FieldNames";
import Context from "../../../../context/Context";
import Button from "../../../../common/components/Button/index";
import Skeleton from "react-loading-skeleton";
import Rdx from "../../../../redux/Rdx";
import OfficePlan from "../../../base/OfficePlan";
import ItemReference from "../../../../aiim/base/ItemReference";
import Attributes from "../../../../components/main/InfoPanel/Attributes";
import RemoveButton from "./RemoveButton";
import UnitsAssignTo from "../UnitsAssignTo";
import UnassignPrompt from "../UnassignPrompt";
import { ModalController } from "../../../../common/components/Modal";
import TransactionGuard from "../../../base/TransactionGuard";
import PeopleAssignTo from "../PeopleAssignTo";
import AreaPopup from "./AreaPopup";
import RelatedFeatures from "./RelatedFeatures";
import * as multipleAssignmentsUtil from "../MultipleAssignments/multipleAssignmentsUtil";
// List Item Icons
import DeleteIcon from "calcite-ui-icons-react/XIcon";
import FloorPlanIcon from "calcite-ui-icons-react/FloorPlanIcon";


const tabs = {
  assignments: "assignments",
  properties: "properties",
  related: "related"
}

export default class Popup extends React.Component {
  _mounted = false

  constructor(props) {
    super(props)
    const type = this.props.isPerson ? "person" : null
    this.state = component.newState({
      spaceplannerActiveTab: Rdx.getValue(null, Rdx.Keys.SPACEPLANNER_ACTIVE_SECTION),
      activeTab: tabs.assignments,
      assignmentsDisabled: false,
      peopleAssigned: [],
      unitsAssigned: [],
      additionalAssignments: {
        units: [],
        areas: []
      },
      relatedItems: 0,
      hotels: [],
      hotdesks: [],
      unitUseType: null,
      type: type
    })
  }

  updateTypes = () => {
    const attributes = this.getFeatureItem().feature.attributes;
    let useType = aiimUtil.getAttributeValue(
      attributes,
      FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE
    );
    useType = useType.toLowerCase()
    let type = "unit"
    if (useType === "not assignable") {
      this.setState({
        activeTab: tabs.properties,
        assignmentsDisabled: true,
        type: type,
        unitUseType: useType
      })
    } else {
      this.setState({
        type: type,
        unitUseType: useType
      })
    }
    return { type: type, useType: useType }
  }

  _focus = () => {
    const popupCloseBtn = document.getElementsByClassName("esri-popup__button")
    if (popupCloseBtn && popupCloseBtn.length === 1) {
      popupCloseBtn[0].focus()
    }
    const popupTitle = document.getElementsByClassName("esri-popup__header-title")
    if (popupTitle && popupTitle.length === 1) {
      popupTitle[0].setAttribute("aria-live", "polite")
    }
  }

  componentDidMount() {
    this._mounted = true
    const attributes = this.getFeatureItem().feature.attributes;
    setTimeout(this._focus, 100)

    if (!this.props.isPerson) {
      const unitName = aiimUtil.getAttributeValue(attributes, FieldNames.NAME);
      Rdx.setValue(null, OfficePlan.Rdx_ActiveUnitName, unitName);
      const types = this.updateTypes()
      this.queryAssignments(types.type, types.useType);
    } else {
      this.queryAssignments("person")
    }

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, (params) => {
        const actions = [OfficePlan.Action_AssignmentsUpdated];
        if (actions && actions.indexOf(params.action) !== -1) {
          this.refreshFeatureItem();
        }
      }),

      Topic.subscribe(Topic.ActiveTabChanged, (params) => {
        if (typeof params.tab === "string") {
          this.setState({
            spaceplannerActiveTab: params.tab
          })
        }
      })
    ]);
  }

  componentWillUnmount() {
    this._mounted = false
    component.componentWillUnmount(this)
  }

  isViewOnly = () => {
    const tab = this.state.spaceplannerActiveTab
    return tab === "review" || tab === "publish"
  }

  changeActiveTab(e, title) {
    this.setState({
      activeTab: title
    })
  }

  getFeatureItem() {
    return this.state.featureItem || this.props.featureItem;
  }

  getSource(type) {
    if (type === "unit" || type === "hotdesk" || type === "hotel") {
      return officePlanUtil.getUnitsSource()
    } else if (type === "person") {
      return officePlanUtil.getPeopleSource()
    } else {
      return null
    }
  }

  queryHotels() {
    return new Promise((resolve, reject) => {
      const officePlan = OfficePlan.getActive();
      officePlan
        .queryHotelAreas()
        .then(result => {
          if (!this._mounted) resolve();
          this.setState({
            hotels: result
          });
          resolve()
        })
        .catch(ex => {
          console.warn("Error querying hotel areas:");
          console.error(ex);
          if (!this._mounted) reject(ex);
          Topic.publishErrorAccessingData();
          reject(ex)
        });
    })
  }

  queryHotdesks() {
    return new Promise((resolve, reject) => {
      const officePlan = OfficePlan.getActive();
      officePlan
        .queryHotDeskAreas()
        .then(result => {
          if (!this._mounted) resolve();
          this.setState({
            hotdesks: result
          });
          resolve()
        })
        .catch(ex => {
          console.warn("Error querying hot desk areas:");
          console.error(ex);
          if (!this._mounted) reject(ex);
          Topic.publishErrorAccessingData();
          reject(ex)
        });
    })
  }

  queryAreas() {
    return Promise.all([this.queryHotels(), this.queryHotdesks()])
  }

  queryAssignments(type, useType) {
    if (useType === "hotel" || useType === "hotdesk") {
      this.queryAreas()
      this.setState({ peopleAssigned: [] })
    } else if (type === "unit") {
      this.queryAreas()
      officePlanUtil
      .queryPeopleAssignedToUnit(this.getFeatureItem())
      .then((result) => {
        if (!this._mounted) return;
        this.setState({
          peopleAssigned: result,
        });
      })
      .catch((ex) => {
        console.error("Error querying people assigned to unit", ex);
      });
    } else if (type === "person") {
      this.queryAdditionalAssignments()
    }
  }

  queryAdditionalAssignments() {
    let initPromise = Promise.resolve()
    const featureItem = this.getFeatureItem();
    const attributes = featureItem.feature.attributes;
    const unitId = aiimUtil.getAttributeValue(attributes,FieldNames.PEOPLE_UNIT_ID);
    if (!unitId) {
      this.setState({
        unitsAssigned: []
      })
    } else {
      const source = sourceUtil.getUnitsSource();
      const unitIdField = aiimUtil.findField(source.layer2D.fields,FieldNames.UNIT_ID);
      const v = selectionUtil.escSqlQuote(unitId);
      const where = "(" + unitIdField.name + " = '" + v + "')";
      const options = {
        source: source,
        where: where,
        returnGeometry: false
      }
      initPromise = queryUtil.queryFeatures(options).then(result => {
        if (result && result.features) {
          const resultInfo = queryUtil.makeResultInfo(source,result);
          if (this._mounted && resultInfo && resultInfo.featureItems &&
              resultInfo.featureItems.length > 0) {
            const unitFeatureItems = resultInfo.featureItems;
            this.setState({
              unitsAssigned: unitFeatureItems
            })
          }
        }
      })
    }

    initPromise.then(() => {
      return this.queryAreas()
    }).then(() => {
      const personName = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_FULLNAME)
      const personEmail = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_EMAIL)
      return multipleAssignmentsUtil.getPersonAssignments(personName, personEmail)
    }).then(assignments => {
      const areas = assignments.areas
      const units = assignments.units
      const personArea = this.findMatchingArea(attributes)
      const personUnit = this.state.unitsAssigned.length === 1 ? this.state.unitsAssigned[0].feature : null
      const additionalAreas = areas.filter(area => {
        return !multipleAssignmentsUtil.compareAreas(area, personArea)
      })
      const additionalUnits = units.filter(unit => {
        return !multipleAssignmentsUtil.compareUnits(unit.feature, personUnit)
      })
      this.setState({
        additionalAssignments: {
          areas: additionalAreas,
          units: additionalUnits
        }
      })
    }).catch(e => {
      console.error("Error querying units/areas/additonal assignments", e)
    })
  }

  findMatchingArea(attributes) {
    const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID)
    if (areaId) {
      if (areaId.includes("hotel")) {
        const hotels = this.state.hotels
        for (let i = 0; i < hotels.length; i++) {
          const hotel = hotels[i]
          const hotelAttributes = hotel.attributes
          const hotelId = aiimUtil.getAttributeValue(hotelAttributes, FieldNames.AREA_ID)
          if (areaId === hotelId) {
            return hotel
          }
        }
      } else if (areaId.includes("hotdesk")) {
        const hotdesks = this.state.hotdesks
        for (let i = 0; i < hotdesks.length; i++) {
          const hotdesk = hotdesks[i]
          const hotdeskAttributes = hotdesk.attributes
          const hotdeskId = aiimUtil.getAttributeValue(hotdeskAttributes, FieldNames.AREA_ID)
          if (areaId === hotdeskId) {
            return hotdesk
          }
        }
      }
    } else return null
  }

  refreshFeatureItem() {
    const source = this.getSource(this.state.type);
    const featureItem = this.getFeatureItem();
    queryUtil
      .refreshFeatureItem(source, featureItem)
      .then((result) => {
        if (result && this._mounted) {
          this.setState({ featureItem: result });
          if (!this.props.isPerson) {
            const types = this.updateTypes()
            this.queryAssignments(types.type, types.useType);
          } else {
            this.queryAssignments("person")
          }
        }
      })
      .catch((ex) => {
        console.error("Popup: Error refreshing feature", ex);
      });
  }

  confirmDelete = (subject, item, from, fromItem) => {
    const i18n = Context.instance.i18n;
    const promptOptions = {
      subject: subject,
      subjectItem: item,
      from: from,
      fromItem: fromItem,
    };
    if (subject === "unit" || subject === "hotel" || subject === "hotdesk") {
      const personAttributes = fromItem.attributes || (fromItem.feature && fromItem.feature.attributes)
      const personName = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
      promptOptions.fromName = personName
    }
    const content = <UnassignPrompt promptOptions={promptOptions} />;
    const controller = new ModalController({});
    let okButton;
    let props = {
      title: i18n.spaceplanner.unassignPrompt.removeAssignmentTitle,
      showOKCancel: true,
      closeOnOK: true,
      okLabel: i18n.spaceplanner.unassign,
      onOK: () => {
        if (okButton) okButton.disable();
        if (subject === "person") {
          const personAttributes = item && item.feature && item.feature.attributes
          const personName = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
          const personEmail = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_EMAIL)
          multipleAssignmentsUtil.canDeleteDuplicate(personName, personEmail).then(result => {
            if (result) {
              this.deleteDuplicatePerson({person: item, associatedUnit: fromItem, associatedArea: null})
            } else {
              this.deletePerson(item)
            }
          })
        }
        if (subject === "unit") {
          if (this.state.unitUseType === "hotdesk" || this.state.unitUseType === "hotel") {
            this.deleteUnit(item)
          } else {
            this.deleteDuplicatePersonFromUnit(item, fromItem)
          }
          // this.deleteUnit(item)
        }
        if (subject === "hotdesk" || subject === "hotel") {
          this.deleteDuplicatePersonFromArea(item, fromItem)
        }
        // Need to support  deleting a unit from area
      },
      onMountOKButton: (btn) => {
        okButton = btn;
      },
    };
    controller.show(props, content);
  };

  deletePerson = (personItem) => {
    const guard = new TransactionGuard({force: true});
    transactions
      .unassignPeople([personItem])
      .then((result) => {
        guard.close();
        if (this.state.type === "person") {
          this.onPersonAssignmentChanged()
        } else {
          Topic.publish(Topic.PlanModified, {
            action: OfficePlan.Action_AssignmentsUpdated,
          });
        }
      })
      .catch((error) => {
        guard.close();
        console.error("Error unassigning people", error);
        Topic.publishErrorUpdatingData(error.submessage);
      });
  };

  deleteDuplicatePerson = (personItem) => {
    const guard = new TransactionGuard({force: true});
    transactions
      .deletePeople([personItem])
      .then((result) => {
        guard.close();
        Topic.publish(Topic.PlanModified, {
          action: OfficePlan.Action_AssignmentsUpdated,
        });
      })
      .catch((error) => {
        guard.close();
        console.error("Error unassigning people", error);
        Topic.publishErrorUpdatingData(error.submessage);
      });
  }

  hasAdditionalAssignments = () => {
    const units = this.state.additionalAssignments.units
    const areas = this.state.additionalAssignments.areas
    return units.length > 0 || areas.length > 0
  }

  isAdditionalUnitAssignment = (unitItem) => {
    const additionalUnits = this.state.additionalAssignments.units
    return additionalUnits.includes(unitItem)
  }

  isAdditionalAreaAssignment = (areaItem)  => {
    const additionalAreas = this.state.additionalAssignments.areas
    return additionalAreas.includes(areaItem)
  }

  deleteDuplicatePersonFromUnit = (unitItem, personItem) => {
    if (this.hasAdditionalAssignments()) {
      const isAdditional = this.isAdditionalUnitAssignment(unitItem)
      const personAttributes = personItem && personItem.feature && personItem.feature.attributes
      const unitAttributes = unitItem && unitItem.feature && unitItem.feature.attributes
      const personName = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
      const personEmail = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_EMAIL)
      const unitId = aiimUtil.getAttributeValue(unitAttributes, FieldNames.UNIT_ID)
      multipleAssignmentsUtil.getDuplicateByUnit(personName, personEmail, unitId, {unit: unitItem}).then(result => {
        if (result && result.length === 1) {
          const person = result[0]
          multipleAssignmentsUtil.deleteDuplicatePeople([person], isAdditional)
        } else {
          throw new Error("No occupants returned")
        }
      }).catch(e => {
        console.error("Couldn't get duplicate occupant feature", e)
      })
    } else {
      this.deletePerson(personItem)
    }
  }

  deleteDuplicatePersonFromArea = (areaItem, personItem) => {
    if (this.hasAdditionalAssignments()) {
      const isAdditional = this.isAdditionalAreaAssignment(areaItem)
      const personAttributes = personItem && personItem.feature && personItem.feature.attributes
      const areaAttributes = areaItem.attributes || (areaItem.feature && areaItem.feature.attributes)
      const personName = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
      const personEmail = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_EMAIL)
      const areaId = aiimUtil.getAttributeValue(areaAttributes, FieldNames.AREA_ID)
      multipleAssignmentsUtil.getDuplicateByArea(personName, personEmail, areaId, {unit: areaItem}).then(result => {
        if (result && result.length === 1) {
          const person = result[0]
          multipleAssignmentsUtil.deleteDuplicatePeople([person], isAdditional)
        } else {
          throw new Error("No occupants returned")
        }
      }).catch(e => {
        console.error("Couldn't get duplicate occupant feature", e)
      })
    } else {
      this.deletePerson(personItem)
    }
  }

  deleteUnit = (unitItem) => {
    const guard = new TransactionGuard({force: true});
    transactions
      .unassignUnits([unitItem])
      .then((result) => {
        guard.close();
        Topic.publish(Topic.PlanModified, {
          action: OfficePlan.Action_AssignmentsUpdated,
          queryCriteriaKey: this.unitsQueryCriteriaKey
        });
      })
      .catch((error) => {
        guard.close();
        console.error("Error unassigning units", error);
        Topic.publishErrorUpdatingData(error.submessage);
      });
  };

  render() {
    return (
      <PopupPanel id="feature-popup" key="info">
        {this.renderLabels(this.state.type)}
        {this.renderContent(this.state.type)}
      </PopupPanel>
    );
  }

  renderLabels(type) {
    const lib = Context.instance.lib
    const i18n = Context.instance.i18n
    const featureItem = this.getFeatureItem()
    const attributes = featureItem && featureItem.feature && featureItem.feature.attributes
    const styleLeft = {justifyContent: "flex-start"}
    const styleCenter = {justifyContent: "center"}
    const styleRight = {justifyContent: "flex-end"}
    if (type === "unit") {
      let useType = aiimUtil.getAttributeValue(
        attributes,
        FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE
      );
      let capacity = aiimUtil.getAttributeValue(
        attributes,
        FieldNames.UNITS_CAPACITY
      );
      let area = aiimUtil.getAttributeValue(
        attributes,
        FieldNames.UNITS_AREA_GROSS
      );
      if (typeof capacity !== "number") capacity = 0;
      if (typeof area !== "number") area = 0;
      if (typeof area === "number") {
        area = lib.dojo.number.format(area, { places: 0 });
      }

      let useTypeCompare = useType && useType.toLowerCase()
      let useTypeLabel, useTypeIcon
      if (useTypeCompare === "office" || useTypeCompare === "none") {
        useTypeLabel = i18n.spaceplanner.assignmentType.officeLabel
        useTypeIcon = (<FloorPlanIcon/>)
      } else if (useTypeCompare === "hotdesk") {
        useTypeLabel = i18n.spaceplanner.assignmentType.hotdesk
        useTypeIcon = (<DeskIcon/>)
      } else if (useTypeCompare === "hotel") {
        useTypeLabel = i18n.spaceplanner.assignmentType.hotel
        useTypeIcon = (<ServicesIcon/>)
      } else {
        useTypeLabel = i18n.spaceplanner.assignmentType.notAssignable
        useTypeIcon = (<CubeIcon/>)
      }
      // let capacityLabel = i18n.spaceplanner.popup.capacity.replace("{count}", capacity)
      // let areaLabel = i18n.spaceplanner.popup.area
      //   .replace("{count}", area)
      //   .replace("{unit}", "ft") // Open up to meters?
      let capacityLabel = capacity
      let areaLabel = area

      return (
        <div className={"i-popup-labels"}>
          <div className={"i-label-group"} style={styleLeft}>
            <h5 className={"i-label"}>{useTypeLabel}</h5>
            <div className={"i-icon"}>{useTypeIcon}</div>
          </div>
          <div className={"i-label-group"} style={styleCenter}>
            <h5 className={"i-label"}>{i18n.spaceplanner.areaStats.capacity}</h5>
            <div className={"i-icon"}><ContentLargeIcon/></div>
            <h5 className={"i-label"}>{capacityLabel}</h5>
          </div>
          <div className={"i-label-group"} style={styleRight}>
            <h5 className={"i-label"}>{i18n.spaceplanner.areaStats.area}</h5>
            <div className={"i-icon"}><MeasureAreaIcon/></div>
            <h5 className={"i-label"}>{areaLabel}</h5>
          </div>
        </div>
      )
    } else if (type === "person") {
      let orgLevel2 = aiimUtil.getAttributeValue(
        attributes,
        FieldNames.PEOPLE_ORG_LEVEL_2
      )
      let jobTitle = aiimUtil.getAttributeValue(
        attributes,
        FieldNames.PEOPLE_JOB_TITLE
      )
      let startDate = aiimUtil.getAttributeValue(
        attributes,
        FieldNames.PEOPLE_START_DATE
      )
      let years, months
      if (startDate) {
        const date1 = new Date(startDate)
        const date2 = new Date() // current date
        const diffTime = date2.getTime() - date1.getTime()
        const diffYears = diffTime / (1000 * 3600 * 24 * 365)
        years = Math.floor(diffYears)
        months = Math.floor((diffYears - years) * 12)
      } else {
        years = 0
        months = 0
      }

      const orgLevel2Label = orgLevel2 || "---"
      const jobTitleLabel = jobTitle || "---"
      const timeEmployedLabel = i18n.spaceplanner.popup.timeEmployed.replace(
        "{years}", years
      ).replace(
        "{months}", months
      )
      return (
        <div className={"i-popup-labels"}>
          <div className={"i-label-group"} style={styleLeft}>
            <div className={"i-icon"}><WidgetsSourceIcon/></div>
            <h5 className={"i-label"}>{orgLevel2Label}</h5>
          </div>
          <div className={"i-label-group"} style={styleCenter}>
            <div className={"i-icon"}><CreditsIcon/></div>
            <h5 className={"i-label"}>{jobTitleLabel}</h5>
          </div>
          <div className={"i-label-group"} style={styleRight}>
            <div className={"i-icon"}><ClockIcon/></div>
            <h5 className={"i-label"}>{timeEmployedLabel}</h5>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  renderContent(type) {
    return (
      <div>
        <div className={"i-current-content"}>
        {this.renderAssignments(type)}
        {this.renderProperties(type)}
        {this.renderRelated(type)}
        </div>
        {this.renderTabs(type)}
      </div>
    )
  }

  isNullGeometry(geometry) {
    return !geometry || (geometry.x === 0 && geometry.y === 0 && geometry.z === 0)
  }

  onPersonAssignmentChanged = () => {
    const personFeature = this.getFeatureItem()
    const initGeometry = personFeature.geometry
    const source = officePlanUtil.getPeopleSource()
    Topic.publish(Topic.PlanModified, {
      action: OfficePlan.Action_AssignmentsUpdated,
    });
    queryUtil
      .refreshFeatureItem(source, personFeature)
      .then((result) => {
        if (result && this._mounted) {
          if (result.geometry !== initGeometry) {
            const attributes = result.feature.attributes
            const name = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_FULLNAME)
            Topic.publish(Topic.ShowItemPopup, {
              view: Context.instance.views.activeView,
              title: name,
              source: source,
              featureItem: result,
              fetchFeatureItemGeometry: !this.isNullGeometry(result.geometry),
              zoom: true,
              content: <Popup sourceKey={source.key} featureItem={result} isPerson={true} />
            })
          }
          // } else {
          //   console.log("else")
          //   Topic.publish(Topic.PlanModified, {
          //     action: OfficePlan.Action_AssignmentsUpdated,
          //   });
          // }
        }
      })
      .catch((ex) => {
        console.error("Popup: Error refreshing feature", ex);
      });
  }

  renderAssignments(type) {
    if (this.state.activeTab !== tabs.assignments) return null
    const useType = this.state.unitUseType
    const i18n = Context.instance.i18n
    let assignBtn, title
    if (type === "unit") {
      if (useType === "hotdesk" || useType === "hotel") {
        title = i18n.spaceplanner.popup.assignedTo
      } else {
        title = i18n.spaceplanner.popup.peopleAssigned
      }
      assignBtn = (
        <UnitsAssignTo type={type} tab={this.state.activeTab}
            featureItems={[this.getFeatureItem()]} isPopup={true} />
      )
    } else if (type === "person") {
      title = i18n.spaceplanner.popup.assignedTo
      assignBtn = (
        // <PeopleAssignTo type={type} tab={this.state.activeTab} isComments={isComments}
        //     featureItems={[this.getFeatureItem()]} isPopup={true} />
        <PeopleAssignTo type={type} tab={this.state.activeTab}
            featureItems={[this.getFeatureItem()]} isPopup={true}
            onAssignment={this.onPersonAssignmentChanged}/>
      )
    }
    const buttons = !this.isViewOnly() ? (
      <div className={"i-btns"}>
        {assignBtn}
        <RemoveButton type={type} unitUseType={useType}
          tab={this.state.activeTab}
          hotels={this.state.hotels}
          hotdesks={this.state.hotdesks}
          peopleFeatures={this.state.peopleAssigned}
          unitFeatures={this.state.unitsAssigned}
          additionalAssignments={this.state.additionalAssignments}
          onUnassignment={this.onPersonAssignmentChanged}
          feature={this.getFeatureItem()} />
      </div>
    ) : null
    const header = (
      <div className={"i-assignments-header"}>
        <h3>{title}</h3>
        {buttons}
      </div>
    )

    if (type === "unit") {
      const peopleAssignments = this.state.peopleAssigned
      const assignments = Array.isArray(peopleAssignments) ? (
        peopleAssignments.map((item, index) => (
          this.renderPersonItem(item, index)
        ))
      ) : (
        <Skeleton count={2} />
      );

      const featureItem = this.getFeatureItem()
      const attributes = featureItem.feature.attributes
      let asnName = officePlanUtil.getUnitAssignmentName(featureItem);
      if (asnName === undefined) {
        console.log("Data problem detected with item: ", featureItem);
        asnName = i18n.spaceplanner.unoccupied;
      }
      const asnType = officePlanUtil.getUnitAssignmentType(featureItem);

      let asnAside = "";
      let areaItem = null
      if (asnType === "hotdesk") {
        const hotdesks = this.state.hotdesks
        const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID)
        for (let i = 0; i < hotdesks.length; i++) {
          const hotdesk = hotdesks[i]
          const hotdeskAttributes = hotdesk.attributes
          const hotdeskId = aiimUtil.getAttributeValue(hotdeskAttributes, FieldNames.AREA_ID)
          if (areaId === hotdeskId) {
            areaItem = hotdesk
            break
          }
        }
        asnAside = !this.isViewOnly() ? (
          <Button
            iconButton={true}
            icon={<DeleteIcon />}
            style={{ marginLeft: "10px" }}
            title={i18n.spaceplanner.unassign}
            onClick={(evt) => {
              if (evt) evt.stopPropagation();
              this.confirmDelete("unit", this.getFeatureItem(), "hotdesk", areaItem);
            }}
          />
        ) : null
      } else if (asnType === "hotel") {
        const hotels = this.state.hotels
        const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID)
        for (let i = 0; i < hotels.length; i++) {
          const hotel = hotels[i]
          const hotelAttributes = hotel.attributes
          const hotelId = aiimUtil.getAttributeValue(hotelAttributes, FieldNames.AREA_ID)
          if (areaId === hotelId) {
            areaItem = hotel
            break
          }
        }
        asnAside = !this.isViewOnly() ? (
          <Button
            iconButton={true}
            icon={<DeleteIcon />}
            style={{ marginLeft: "10px" }}
            title={i18n.spaceplanner.unassign}
            onClick={(evt) => {
              if (evt) evt.stopPropagation();
              this.confirmDelete("unit", this.getFeatureItem(), "hotel", areaItem);
            }}
          />
        ) : null
      }
      const isUnassigned = officePlanUtil.isUnitUnassigned(featureItem);
      const hasPeopleAssigned = peopleAssignments && peopleAssignments.length > 0 &&
        asnType !== "hotdesk" && asnType !== "hotel"

      const popupArea = () => {
        if (asnType !== "hotdesk" && asnType !== "hotel" && !areaItem) return
        Topic.publish(Topic.ShowItemPopup, {
          view: Context.instance.views.activeView,
          title: asnName,
          featureItem: areaItem,
          fetchFeatureItemGeometry: false,
          zoom: false,
          content: <AreaPopup areaItem={areaItem} type={asnType} />
        })
      }

      const noCloseButton = (!asnAside || typeof asnAside === "string")
      const listItem = noCloseButton ? (
        <ListItem noMargin unassigned={isUnassigned} onClick={popupArea}>
          <ListItemTitle>
            <ListItemTitleMain>{asnName}</ListItemTitleMain>
            <ListItemTitleAside>{asnAside}</ListItemTitleAside>
          </ListItemTitle>
        </ListItem>
      ) : (
        <ListItem isRtl={Context.instance.uiMode.isRtl} isPopup={true} isViewOnly={this.isViewOnly()} noMargin
          unassigned={isUnassigned} onClick={popupArea}>
          <ListItemTitle>
            <ListItemTitleMain>{asnName}</ListItemTitleMain>
            <ListItemTitleAside>{asnAside}</ListItemTitleAside>
          </ListItemTitle>
        </ListItem>
      )
      return (
        <div id="assignments" className={"i-tab-content"}>
          {header}
          <AssignmentsContent>
            {hasPeopleAssigned ? (
              assignments
            ) : (
              <List>
                {listItem}
              </List>
            )}
          </AssignmentsContent>
        </div>
      )
    } else if (type === "person") {
      const featureItem = this.getFeatureItem()
      let asnName = officePlanUtil.getPersonAssignmentName(featureItem);
      const attributes = featureItem.feature.attributes
      const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID)
      let hasUnitAssigned = this.state.unitsAssigned && this.state.unitsAssigned.length > 0 &&
        !areaId
      let asnType = null
      if (areaId && areaId.includes("hotel")) asnType = "hotel"
      else if (areaId && areaId.includes("hotdesk")) asnType = "hotdesk"

      if (asnName === undefined) {
        console.log("Data problem detected with item: ", featureItem);
        asnName = i18n.spaceplanner.unoccupied;
      }

      let asnAside = null
      let areaItem = null
      if (asnType === "hotel") {
        const hotels = this.state.hotels
        const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID)
        for (let i = 0; i < hotels.length; i++) {
          const hotel = hotels[i]
          const hotelAttributes = hotel.attributes
          const hotelId = aiimUtil.getAttributeValue(hotelAttributes, FieldNames.AREA_ID)
          if (areaId === hotelId) {
            areaItem = hotel
            break
          }
        }
        asnAside = !this.isViewOnly() ? (
          <Button
            iconButton={true}
            icon={<DeleteIcon />}
            style={{ marginLeft: "10px" }}
            title={i18n.spaceplanner.unassign}
            onClick={(evt) => {
              if (evt) evt.stopPropagation();
              this.confirmDelete("hotel", areaItem, "person", this.getFeatureItem());
            }}
          />
        ) : null
      } else if (asnType === "hotdesk") {
        const hotdesks = this.state.hotdesks
        const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID)
        for (let i = 0; i < hotdesks.length; i++) {
          const hotdesk = hotdesks[i]
          const hotdeskAttributes = hotdesk.attributes
          const hotdeskId = aiimUtil.getAttributeValue(hotdeskAttributes, FieldNames.AREA_ID)
          if (areaId === hotdeskId) {
            areaItem = hotdesk
            break
          }
        }
        asnAside = !this.isViewOnly() ? (
          <Button
            iconButton={true}
            icon={<DeleteIcon />}
            style={{ marginLeft: "10px" }}
            title={i18n.spaceplanner.unassign}
            onClick={(evt) => {
              if (evt) evt.stopPropagation();
              this.confirmDelete("hotdesk", areaItem, "person", this.getFeatureItem());
            }}
          />
        ) : null
      }

      const unitAssignments = this.state.unitsAssigned
      const assignments = hasUnitAssigned ? (
        unitAssignments.map((item, index) => (
          this.renderUnitItem(item, index)
        ))
      ) : (
        <Skeleton count={2} />
      );

      const isUnassigned = officePlanUtil.isPersonUnassigned(featureItem);

      const popupArea = () => {
        if (asnType !== "hotdesk" && asnType !== "hotel" && !areaItem) return
        Topic.publish(Topic.ShowItemPopup, {
          view: Context.instance.views.activeView,
          title: asnName,
          featureItem: areaItem,
          fetchFeatureItemGeometry: false,
          zoom: false,
          content: <AreaPopup areaItem={areaItem} type={asnType} />
        })
      }

      const noCloseButton = (!asnAside || typeof asnAside === "string")
      const icon = asnType === "hotel" ? <ServicesIcon/> : asnType === "hotdesk" ? <DeskIcon/> : null
      const listItem = noCloseButton ? (
        <ListItem noMargin unassigned={isUnassigned} onClick={popupArea}>
          <ListItemTitle>
            <ListItemTitleIcon>{icon}</ListItemTitleIcon>
            <ListItemTitleMain>{asnName}</ListItemTitleMain>
            <ListItemTitleAside>{asnAside}</ListItemTitleAside>
          </ListItemTitle>
        </ListItem>
      ) : (
        <ListItem isRtl={Context.instance.uiMode.isRtl} isPopup={true} isViewOnly={this.isViewOnly()} noMargin
          unassigned={isUnassigned} onClick={popupArea}>
          <ListItemTitle>
            <ListItemTitleIcon>{icon}</ListItemTitleIcon>
            <ListItemTitleMain>{asnName}</ListItemTitleMain>
            <ListItemTitleAside>{asnAside}</ListItemTitleAside>
          </ListItemTitle>
        </ListItem>
      )
      const additionalAssignments = this.renderAdditionalAssignments(type)
      return (
        <div id="assignments" className={"i-tab-content"}>
          {header}
          <AssignmentsContent>
            {hasUnitAssigned ? (
              assignments
            ) : (
              <List>
                {listItem}
              </List>
            )}
            {additionalAssignments}
          </AssignmentsContent>
        </div>
      )
    } else {
      return null
    }
  }

  renderAdditionalAssignments = (type) => {
    const { additionalAssignments } = this.state
    const { areas, units } = additionalAssignments
    if (type !== "person" || (areas.length === 0 && units.length === 0)) return null
    const i18n = Context.instance.i18n
    const title = i18n.spaceplanner.multipleAssignments.popupTitle
    const renderAreas = areas.map(area => this.renderAdditionalAreaItem(area))
    const renderUnits = units.map(unit => this.renderAdditionalUnitItem(unit))
    return (
      <div className="i-additional-assignments">
        <h4>{title}</h4>
        <ul>
          {renderAreas}
          {renderUnits}
        </ul>
      </div>
    )
  }

  renderAdditionalAreaItem = (areaItem) => {
    const i18n = Context.instance.i18n
    const isAdditionalAssignment = true
    const areaName = aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_NAME)
    const areaId = aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID)
    const areaType = aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_TYPE)
    const asnAside = !this.isViewOnly() ? (
      <Button
        iconButton={true}
        icon={<DeleteIcon />}
        style={{ marginLeft: "10px" }}
        title={i18n.spaceplanner.unassign}
        onClick={(evt) => {
          if (evt) evt.stopPropagation();
          this.confirmDelete(areaType, areaItem, "person", this.getFeatureItem());
        }}
      />
    ) : null
    const popupArea = () => {
      Topic.publish(Topic.ShowItemPopup, {
        view: Context.instance.views.activeView,
        title: areaName,
        featureItem: areaItem,
        fetchFeatureItemGeometry: false,
        zoom: false,
        content: <AreaPopup areaItem={areaItem} type={areaType} />
      })
    }
    const icon = areaType === "hotel" ? <ServicesIcon/> : areaType === "hotdesk" ? <DeskIcon/> : null
    return (
      <ListItem
        isViewOnly={this.isViewOnly()}
        key={areaId}
        isRtl={Context.instance.uiMode.isRtl}
        isPopup={true} noMargin
        unassigned={false}
        onClick={popupArea}>
        <ListItemTitle>
          <ListItemTitleIcon lowerIcon={areaType === "hotdesk"}>{icon}</ListItemTitleIcon>
          <ListItemTitleMain>{areaName}</ListItemTitleMain>
          <ListItemTitleAside>{asnAside}</ListItemTitleAside>
        </ListItemTitle>
      </ListItem>
    )
  }

  renderAdditionalUnitItem = (unitItem) => {
    const unitId = aiimUtil.getAttributeValue(unitItem.feature.attributes, FieldNames.UNIT_ID)
    return this.renderUnitItem(unitItem, unitId, true)
  }

  renderPersonItem = (item, index) => {
    const i18n = Context.instance.i18n;
    const field = FieldNames.PEOPLE_FULLNAME;
    let addClass = false;

    const dragStart = (evt) => {
      addClass = true;
      const source = officePlanUtil.getPeopleSource();
      evt.dataTransfer.dropEffect = "copy";  // copy move link
      Topic.publish(Topic.DragItemStart, {
        sourceKey: source.key,
        featureItem: item
      });
    };

    const dragging = () => {
      if (addClass) {
        document.body.classList.add("i-drag-from-popup");
        addClass = false;
      }
    }

    const dragEnd = () => {
      addClass = false;
      const source = officePlanUtil.getPeopleSource();
      Topic.publish(Topic.DragItemEnd, {
        sourceKey: source.key,
        featureItem: item
      });
      setTimeout(() => {
        document.body.classList.remove("i-drag-from-popup");
      }, 1000);
    }

    const openPersonPopup = (e, personFeature) => {
      const attributes = personFeature.feature.attributes
      const source = officePlanUtil.getPeopleSource()
      const name = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_FULLNAME)
      Topic.publish(Topic.ShowItemPopup, {
        view: Context.instance.views.activeView,
        title: name,
        source: source,
        featureItem: personFeature,
        fetchFeatureItemGeometry: true,
        zoom: false,
        content: <Popup sourceKey={source.key} featureItem={personFeature} isPerson={true} />
      })
    }

    const deleteButton = !this.isViewOnly() ? (
      <ListItemTitleAside>
        <Button
          iconButton={true}
          icon={<DeleteIcon />}
          style={{ marginLeft: "10px" }}
          title={i18n.spaceplanner.unassign}
          onClick={(evt) => {
            if (evt) evt.stopPropagation();
            this.confirmDelete("person", item, "unit", this.getFeatureItem());
          }}
        />
      </ListItemTitleAside>
    ) : null

    return this.isViewOnly() ? (
      <ListItem key={index} isPopup={true} isViewOnly={this.isViewOnly()} isRtl={Context.instance.uiMode.isRtl}
      onClick={e => {openPersonPopup(e, item)}}
      >
      <ListItemTitle>
        <ListItemTitleMain>
          {aiimUtil.getAttributeValue(item.feature.attributes, field)}
        </ListItemTitleMain>
        {deleteButton}
        </ListItemTitle>
      </ListItem>
    ) : (
      <ListItem key={index} isPopup={true} isViewOnly={this.isViewOnly()} isRtl={Context.instance.uiMode.isRtl}
      draggable onDragStart={dragStart} onDrag={dragging} onDragEnd={dragEnd}
      onClick={e => {openPersonPopup(e, item)}}
      >
      <ListItemTitle>
        <ListItemTitleMain>
          {aiimUtil.getAttributeValue(item.feature.attributes, field)}
        </ListItemTitleMain>
        {deleteButton}
        </ListItemTitle>
      </ListItem>
    );
  }

  renderUnitItem = (item, index, isAdditionalAssignment) => {
    const i18n = Context.instance.i18n;
    const field = FieldNames.NAME;

    const openUnitPopup = (e, unitFeature) => {
      const attributes = unitFeature.feature.attributes
      const source = officePlanUtil.getUnitsSource()
      const name = aiimUtil.getAttributeValue(attributes, FieldNames.NAME)
      Topic.publish(Topic.ShowItemPopup, {
        view: Context.instance.views.activeView,
        title: name,
        source: source,
        featureItem: unitFeature,
        fetchFeatureItemGeometry: true,
        zoom: true,
        content: <Popup sourceKey={source.key} featureItem={unitFeature} isPerson={false} />
      })
    }

    const deleteButton = !this.isViewOnly() ? (
      <ListItemTitleAside>
        <Button
          iconButton={true}
          icon={<DeleteIcon />}
          style={{ marginLeft: "10px" }}
          title={i18n.spaceplanner.unassign}
          onClick={(evt) => {
            if (evt) evt.stopPropagation();
            this.confirmDelete("unit", item, "person", this.getFeatureItem());
          }}
        />
      </ListItemTitleAside>
    ) : null

    return(
      <ListItem key={index} isPopup={true} isViewOnly={this.isViewOnly()} isRtl={Context.instance.uiMode.isRtl}
        onClick={e => {openUnitPopup(e, item)}}
      >
      <ListItemTitle>
        <ListItemTitleIcon lowerIcon>
          <FloorPlanIcon/>
        </ListItemTitleIcon>
        <ListItemTitleMain>
          {aiimUtil.getAttributeValue(item.feature.attributes, field)}
        </ListItemTitleMain>
        {deleteButton}
        </ListItemTitle>
      </ListItem>
    );
  }

  renderProperties(type) {
    if (!type) return null
    if (this.state.activeTab !== tabs.properties) return null
    const featureItem = this.getFeatureItem();
    const item = new ItemReference()
    const source = this.getSource(type)
    if (!source) return null
    item._fromFeature(source.key, featureItem.feature)
    return (
      <div id="properties" className={"i-tab-content"}>
        <Attributes item={item} active={true} source={source} popup={true} />
      </div>
    )
  }

  renderRelated(type) {
    if (!type) return null
    const style = {}
    if (this.state.activeTab !== tabs.related) style.display = "none"
    const featureItem = this.getFeatureItem();
    const item = new ItemReference()
    const source = this.getSource(type)
    if (!source) return null
    item._fromFeature(source.key, featureItem.feature)
    return (
      <div id="related" className={"i-tab-content"} style={style}>
        <RelatedFeatures item={item} feature={featureItem}
          type={type} setRelatedItems={this.setRelatedItems} />
      </div>
    )
  }

  setRelatedItems = (count) => {
    this.setState({
      relatedItems: count
    })
  }

  renderTabs(type) {
    const i18n = Context.instance.i18n
    const activeTab = this.state.activeTab
    let assignmentsCount
    if (type === "unit") {
      assignmentsCount = this.state.peopleAssigned && this.state.peopleAssigned.length
    } else if (type === "person") {
      assignmentsCount = this.state.unitsAssigned && this.state.unitsAssigned.length
    }
    let assignmentsTabLabel = i18n.spaceplanner.popup.assignments
    if (assignmentsCount) {
      assignmentsTabLabel = i18n.spaceplanner.popup.assignmentsCount
      assignmentsTabLabel = assignmentsTabLabel.replace("{count}", assignmentsCount)
    }
    let relatedCount = this.state.relatedItems
    let relatedTabLabel = i18n.spaceplanner.popup.related
    if (relatedCount > 0) {
      relatedTabLabel = i18n.spaceplanner.popup.relatedCount
        .replace("{count}", relatedCount)
    }

    const clsAssignments = activeTab === tabs.assignments ? "i-tab i-tab-active" : "i-tab"
    const clsProperties = activeTab === tabs.properties ? "i-tab i-tab-active" : "i-tab"
    const clsRelated = activeTab === tabs.related ? "i-tab i-tab-active" : "i-tab"

    let tabAssignments
    if (this.state.assignmentsDisabled) {
      tabAssignments = (
        <button id="tab-assignments" disabled
          aria-selected={activeTab === tabs.assignments}
          className={"i-tab i-tab-disabled"} role="tab">{assignmentsTabLabel}</button>
      )
    } else {
      tabAssignments = (
        <button id="tab-assignments" onClick={e => this.changeActiveTab(e, tabs.assignments)}
          aria-selected={activeTab === tabs.assignments}
          className={clsAssignments} role="tab">{assignmentsTabLabel}</button>
      )
    }
    const tabProperties = (
      <button id="tab-properties" onClick={e => this.changeActiveTab(e, tabs.properties)}
        aria-selected={activeTab === tabs.properties}
        className={clsProperties} role="tab">{i18n.spaceplanner.popup.properties}</button>
    )
    // CHANGE TO RELATEDCOUNT
    const tabRelated = (
      <button id="tab-related" onClick={e => this.changeActiveTab(e, tabs.related)}
        aria-selected={activeTab === tabs.related}
        className={clsRelated} role="tab">{relatedTabLabel}</button>
    )

    // Need people and units tabs

    if (type === "unit" || type === "person") {
      return (
        <nav className={"i-popup-tabs"}>
          {tabAssignments}
          {tabProperties}
          {tabRelated}
        </nav>
      )
    } else {
      return null
    }
  }
}
